<!--
 * @Author: Merlin
 * @Date: 2025-01-23 10:35:41
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-05 20:01:01
 * @Description: 将访问的地址不存在时，中间件将跳到 /404 （本页） 
-->
<template>
    <div class="the-404-page">
        <Empty :content="' '" >
            <img class="pic w-[165px]" src="@/assets/imgs/status_404.webp" />
            <!-- <h3 class="code-title">
                404
            </h3> -->
            <p class="text">
                {{
                    $t('commonInfo.pageNotFound')
                    +
                    (sFrom ? `: ${sFrom}` : '')
                }}
            </p>
            <div>
                <span @click="fnGoHome" class="link">
                    <QIcon name="home" />
                    {{ $t('commonInfo.goHomePage') }}
                </span>
            </div>
        </Empty>
    </div>
</template>

<script lang="ts" >
export default defineComponent({ name: 'the_404_page' });
</script>

<script lang="ts" setup>
definePageMeta({
    name: 'The404Page',
});
// useHead(() => ({
//     status: 404,
//     title: "Page not found",
// }));

const router = useRouter();
const oRoute = useRoute();
const sForm = oRoute.query?.from || '' as any;
console.log('sForm', sForm, '◆', decodeURIComponent(sForm));
const sFrom = ref(decodeURIComponent(sForm));

const fnGoHome = ()=>{
    const sPath = getLocalPath('/');
    // clearError({ redirect: sPath });
    // location.href = sPath;
    console.log('点击了回首页 =>', sPath);
    router.push({ path: sPath });
};

</script>

<style scoped lang="scss">
.the-404-page{
    padding-top: 10vh;
}

.code-title{
    font-size: 38px;
    font-weight: bold; 
    margin: 10px auto 00px;
}
.text{
    font-size: 14px;
    font-weight: 600; 
    margin: 00px auto 15px;
    color: var(--Text-Secondary);
    max-width: 88vw;
    word-break: break-all;
}

.text.stack{
    white-space: pre-line;
    word-break: break-all;
    opacity: 0.9;
}

.link{
    cursor: pointer;
    color: var(--Text-Secondary);
    .q-icon{
        font-size: 1.18em;
    }
}

</style>

